// extracted by mini-css-extract-plugin
export default {"layer":"XwStxi","openLayer":"P8BuJj","close":"cEZMcq","closeLayer":"e2XeIu"};